import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { isPartOfElmoExpTreatment, elmoTreatmentNames } from '../../lib/experiments-helper';
import { isKMSearchEnabled } from '../../lib/kmSearchHelper';

const suggestionsCache = {};

export const resetSuggestions = () => ({ type: types.RESET_SUGGESTIONS });

export const showSuggestions = () => ({ type: types.SHOW_SUGGESTIONS });

export function requestSuggestions(text) {
  return {
    type: types.REQUEST_SUGGESTIONS,
    payload: { text },
  };
}

export function receiveSuggestions(query, autoComplete) {
  return {
    type: types.RECEIVE_SUGGESTIONS,
    payload: { query, autoComplete },
  };
}

export function receiveSuggestionsError() {
  return {
    type: types.RECEIVE_SUGGESTIONS_ERROR,
  };
}

export function updateSuggestionsFromCache(query, autoComplete) {
  return {
    type: types.UPDATE_SUGGESTIONS_FROM_CACHE,
    payload: { query, autoComplete },
  };
}

export function getSuggestions(query) {
  return (dispatch, getState) => {
    dispatch(requestSuggestions(query));

    const elmoTreatments = getState().app.elmoTreatments || [];
    let url = `/smarthelp/auto-complete?q=${query}`;
    if (isKMSearchEnabled() || (isPartOfElmoExpTreatment(elmoTreatments, elmoTreatmentNames.kmSearchEnabled))) {
      url = `/smarthelp/km-search-auto-complete?q=${query}`;
    }

    return axios.get(url)
      .then((response) => {
        const { autoComplete } = response.data;
        if (autoComplete.length) {
          suggestionsCache[query] = autoComplete; // update the cache
        }

        dispatch(receiveSuggestions(query, autoComplete));
      })
      .catch(() => {
        dispatch(receiveSuggestionsError());
      });
  };
}

export const clearSuggestions = () => (dispatch) => {
  dispatch(resetSuggestions());
};

export const enableSuggestions = () => (dispatch) => {
  dispatch(showSuggestions());
};

export default function updateSuggestions(query) {
  return (dispatch) => {
    if (query in suggestionsCache) {
      dispatch(updateSuggestionsFromCache(query, suggestionsCache[query]));
    } else {
      dispatch(getSuggestions(query));
    }
  };
}
